import { React, Component } from "react";
import { PasswordReset } from "../../react-cognito";
import { connect } from "react-redux";
import PasswordResetForm from "./forgotPasswordForm";

class ForgotPassword extends Component {
  render() {
    return (
      <PasswordReset>
        <PasswordResetForm />
      </PasswordReset>
    );
  }
}

export default connect(
  null,
  null
)(ForgotPassword);
